import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { countriesAPI } from "../../api/countries/countries"

const initialState = {
    status: null,
    error: null,
    countries: []
}

export const upload = createAsyncThunk(
    'selectCity/upload',
    async (_, {rejectWithValue}) => {
        const resp = await countriesAPI.upload()
        if (!resp.ok) {
            return rejectWithValue({"err": "something_went_wrong"})
        }
        return {countries: resp.countries}
    }
)

const selectCitySlice = createSlice({
    name: 'selectCity',
    initialState,
    extraReducers(builder) {
        builder.addCase(upload.fulfilled, (state, action) => {
            state.status = 'fulfilled'
            state.error = null
            state.countries = action.payload.countries ? action.payload.countries : [] 
        })
        builder.addCase(upload.rejected, (state, action) => {
            state.status = 'rejected'
            state.error = action.payload.err ?? 'something_went_wrong'
            state.countries = []
        })
    }
})

export default selectCitySlice.reducer

export const selectCountries = state => state.selectCity.countries